import React, { useState } from 'react';
import { AuthLayout } from '../../../components/AuthLayout';
import Logo from '../../../assets/images/logo.png';
import { useMobile } from '../../../hooks/useMobile';

export const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const isMobile = useMobile();

    const handleResetRequest = (e: React.FormEvent) => {
        e.preventDefault();
        console.log('Reset link requested for:', email);
    };

    const containerStyle: React.CSSProperties = {
        width: isMobile ? '95%' : '75%',
        backgroundColor: '#fff',
        margin: '40px auto',
        borderRadius: '20px',
        boxShadow: '0px 4px 24px 0px #00000040', 
        padding: '40px 30px',
        textAlign: 'center',
        fontFamily: 'Manrope, sans-serif'
    };

    const inputStyle: React.CSSProperties = {
        width: '100%',
        padding: '12px',
        borderRadius: '8px',
        border: 'none',
        color: '#1F2933',
        fontSize: '16px',
        outline: 'none',
        backgroundColor: '#E6E8EC', 
        boxSizing: 'border-box',
    };

    return (
        <AuthLayout directory="/login" showBackLink={true}>
            <div style={containerStyle}>
                <img src={Logo} alt="Logo" style={{ width: '30%' }} />
                
                <h1 style={{ fontSize: '24px', fontWeight: '700', margin: '40px 0px 10px', color: '#1F2933' }}>
                    Forgot Password
                </h1>
                <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '30px' }}>
                    Enter your email and we'll send you a reset link.
                </p>

                <form onSubmit={handleResetRequest} style={{ textAlign: 'left' }}>
                    <div style={{ marginBottom: '30px' }}>
                        <label style={{ 
                            display: 'block', 
                            marginBottom: '8px', 
                            fontSize: '14px', 
                            fontWeight: '700', 
                            color: '#4B5563' 
                        }}>
                            Email
                        </label>
                        <input 
                            type="email" 
                            placeholder="eddy****@gmail.com" 
                            style={inputStyle} 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        style={{
                            width: '100%',
                            padding: '16px',
                            backgroundColor: '#1A2238', 
                            color: 'white',
                            border: 'none',
                            borderRadius: '12px',
                            fontSize: '18px',
                            fontWeight: '300',
                            cursor: 'pointer'
                        }}
                    >
                        Send Reset Link
                    </button>
                </form>
            </div>
        </AuthLayout>
    );
};